module.exports = __webpack_public_path__ + "static/img/buying-new-car-choose-right-price-thumbnail.bcf8e56.jpg";